import { ITreeNode } from "../../../../../../libs/ts/WorkflowTree/Nodes/ITreeNode"
import { Title } from "../../components/Title"
import { IndicatorType, WorkflowIndicator } from "../../components/WorkflowIndicator"
import { useWorkflowIndicator } from "../../hooks/useWorkflowIndicator"
import { JbpTreeNodeData } from "../../treeExtensions/JbpTreeNodeData"
import { IJbpChildNodeRelationship } from "../../treeExtensions/IJbpChildNodeRelationship"
import { Fields } from "../Fields"

export interface props {
    node: ITreeNode<JbpTreeNodeData, IJbpChildNodeRelationship>,
    mpan: string
}

export const InfoView = (props: props) => {

    const { isFirst, isLast } = useWorkflowIndicator(props.node);

    const handleIsValid = (valid: boolean) => {
        props.node.SetIsSatisfied(valid);
    }

    return (
        <div id="info-view" className="flex flex-row bg-elevation-1 mr-8">
            <WorkflowIndicator type={IndicatorType.Info} isFirst={isFirst} isLast={isLast} title={props.node.Data().Title()} />
            <div>
                <Title className="mt-7 mb-5 font-italic text-sm" text={props.node.Data().Title()} />
                <Fields node={props.node} isValid={handleIsValid} />
            </div>
        </div>
    )
}
